import React from 'react';
import styles from './s.module.less';

const Tip: React.FC = () => (
    <div className={styles.tipContainer}>
        <div className={styles.icon} />
        <span className={styles.text}>
            Adding plans helps patients know whether their insurance is accepted — and helps prevent confusion or mismatches during booking.
        </span>
    </div>
);

export default Tip;
